/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuySharedFAQAuthor_author = {
    readonly sellerPreferences: {
        readonly label: string | null;
        readonly urlLabel: string | null;
        readonly scrollLogo: string | null;
    } | null;
    readonly " $refType": "BuySharedFAQAuthor_author";
};
export type BuySharedFAQAuthor_author$data = BuySharedFAQAuthor_author;
export type BuySharedFAQAuthor_author$key = {
    readonly " $data"?: BuySharedFAQAuthor_author$data;
    readonly " $fragmentRefs": FragmentRefs<"BuySharedFAQAuthor_author">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuySharedFAQAuthor_author",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SellerPreferences",
      "kind": "LinkedField",
      "name": "sellerPreferences",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlLabel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "scrollLogo",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Seller",
  "abstractKey": null
};
(node as any).hash = '4bad06d3e5eb23331e7d4981606cbb4a';
export default node;
